type ObjectWithId = { Id?: string; id?: string };

export const getObjectId = <Object extends ObjectWithId>(object: Object): string => {
  if ((object.id === undefined || object.id === null) && (object.Id === undefined || object.Id === null)) {
    throw new Error(`Value has missing id`);
  }

  return object.id ?? object.Id ?? '';
};
